import { tv } from '~/utils/tv'

export const InputMultiSelectClearButtonContainerVariants = tv({
  base: 'input-text-clear-button group-active:hidden',
  variants: {
    size: {
      md: '-mr-[0.375rem]',
      ml: '-mr-[0.5rem]',
      lg: '-mr-[0.5rem]',
      xl: '-mr-[0.5rem]',
    },
    readOnly: { true: 'invisible hidden' },
    disabled: { true: 'invisible hidden' },
    isActive: { true: '' },
  },
  compoundVariants: [
    {
      readOnly: false,
      disabled: false,
      isActive: true,
      class:
        'peer-focus/field:peer-[:not(:placeholder-shown)]/field:visible peer-focus/field:peer-[:not(:placeholder-shown)]/field:flex group-hover:peer-[:not(:placeholder-shown)]/field:flex',
    },
  ],
  defaultVariants: {
    readOnly: false,
    disabled: false,
  },
})

export const InputMultiSelectClearButtonVariants = tv({
  base: 'px-none',
  variants: {
    size: {
      md: 'h-medium w-medium',
      ml: 'h-mediumlarge w-mediumlarge',
      lg: 'h-mediumlarge w-mediumlarge',
      xl: 'h-mediumlarge w-mediumlarge',
    },
  },
})
